export const UPDATE_LOTSIZE_FIELDS = 'UPDATE_LOTSIZE_FIELDS';

interface UpdateLotsizeFields {
  type: typeof UPDATE_LOTSIZE_FIELDS;
  payload: Partial<ILotsizeFields>;
}

export type LotsizeActionTypes = UpdateLotsizeFields;